import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cookiespolicy',
  templateUrl: './cookiespolicy.component.html',
  styleUrls: ['./cookiespolicy.component.css']
})
export class CookiespolicyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
